import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
  userFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
  userFarms: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  animalConditions: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },  
  animalTypes: {
    requesting: false,
    items: null,
    error: null,
    success: false,
    filters: {},
  },
  cattleBreedList: {
    requesting: false,
    items: null,
    error: null,
    success: false,
    filters: {},
  },
  hornStatusList: {
    requesting: false,
    items: null,
    error: null,
    success: false,
    filters: {},
  },
  goatBreedList: {
    requesting: false,
    items: null,
    error: null,
    success: false,
    filters: {},
  },
  sheepBreedList: {
    requesting: false,
    items: null,
    error: null,
    success: false,
    filters: {},
  },
};

export const dynamicListSlice = createSlice({
  name: 'dynamicList',
  initialState,
  reducers: {
    getUserFarmers: (state, action) => {		      
        state.userFarmers.requesting = true;
        state.userFarmers.error = null;
        state.userFarmers.items = [];
        state.userFarmers.success = false;
        state.userFarmers.filters = action.payload;
    },
    getUserFarmersSuccess: (state, action) => {
      console.log(action.payload);
      state.userFarmers.requesting = false;
      state.userFarmers.items = action.payload;
      state.userFarmers.success = true; 
    },
    getUserFarmersFail: (state, action) => {        
        state.userFarmers.requesting = false;
        state.userFarmers.error = action.payload;
    },  
    
    getUserFarms: (state, action) => {		      
      state.userFarms.requesting = true;
      state.userFarms.error = null;
      state.userFarms.items = [];
      state.userFarms.success = false;
      state.userFarms.filters = action.payload;
    },
    getUserFarmsSuccess: (state, action) => {
      state.userFarms.requesting = false;
      state.userFarms.items = action.payload;
      state.userFarms.success = true; 
    },
    getUserFarmsFail: (state, action) => {        
        state.userFarms.requesting = false;
        state.userFarms.error = action.payload;
    },

    getAnimalConditions: (state, action) => {		      
      state.animalConditions.requesting = true;
      state.animalConditions.error = null;
      state.animalConditions.items = [];
      state.animalConditions.success = false;
      state.animalConditions.filters = action.payload;
    },
    getAnimalConditionsSuccess: (state, action) => {
      state.animalConditions.requesting = false;
      state.animalConditions.items = action.payload;
      state.animalConditions.success = true; 
    },
    getAnimalConditionsFail: (state, action) => {        
      state.animalConditions.requesting = false;
      state.animalConditions.error = action.payload;
    },

    getAnimalTypes: (state, action) => {		      
      state.animalTypes.requesting = true;
      state.animalTypes.error = null;
      state.animalTypes.items = [];
      state.animalTypes.success = false;
      state.animalTypes.filters = action.payload;
    },
    getAnimalTypesSuccess: (state, action) => {
      state.animalTypes.requesting = false;
      state.animalTypes.items = action.payload;
      state.animalTypes.success = true; 
    },
    getAnimalTypesFail: (state, action) => {        
      state.animalTypes.requesting = false;
      state.animalTypes.error = action.payload;
    },

    getCattleBreeds: (state, action) => {		
      state.cattleBreedList.requesting = true;
      state.cattleBreedList.error = null;
      state.cattleBreedList.items = [];
      state.cattleBreedList.success = false;
      state.cattleBreedList.filters = action.payload;
    },
    getCattleBreedsSuccess: (state, action) => {
      state.cattleBreedList.requesting = false;        
      state.cattleBreedList.items = action.payload;
      state.cattleBreedList.success = true; 
    },
    getCattleBreedsFail: (state, action) => {        
      state.cattleBreedList.requesting = false;
      state.cattleBreedList.error = action.payload;
    },

    getHornStatus: (state, action) => {		
      state.hornStatusList.requesting = true;
      state.hornStatusList.error = null;
      state.hornStatusList.items = [];
      state.hornStatusList.success = false;
      state.hornStatusList.filters = action.payload;
    },
    getHornStatusSuccess: (state, action) => {
      state.hornStatusList.requesting = false;        
      state.hornStatusList.items = action.payload;
      state.hornStatusList.success = true; 
    },
    getHornStatusFail: (state, action) => {        
      state.hornStatusList.requesting = false;
      state.hornStatusList.error = action.payload;
    },

    getGoatBreeds: (state, action) => {		
      state.goatBreedList.requesting = true;
      state.goatBreedList.error = null;
      state.goatBreedList.items = [];
      state.goatBreedList.success = false;
      state.goatBreedList.filters = action.payload;
    },
    getGoatBreedsSuccess: (state, action) => {
      state.goatBreedList.requesting = false;        
      state.goatBreedList.items = action.payload;
      state.goatBreedList.success = true; 
    },
    getGoatBreedsFail: (state, action) => {        
      state.goatBreedList.requesting = false;
      state.goatBreedList.error = action.payload;
    },

    getSheepBreeds: (state, action) => {		
      state.sheepBreedList.requesting = true;
      state.sheepBreedList.error = null;
      state.sheepBreedList.items = [];
      state.sheepBreedList.success = false;
      state.sheepBreedList.filters = action.payload;
    },
    getSheepBreedsSuccess: (state, action) => {
      state.sheepBreedList.requesting = false;        
      state.sheepBreedList.items = action.payload;
      state.sheepBreedList.success = true; 
    },
    getSheepBreedsFail: (state, action) => {        
      state.sheepBreedList.requesting = false;
      state.sheepBreedList.error = action.payload;
    },
    
  },
})

export const { 
  getUserFarmers, getUserFarmersSuccess, getUserFarmersFail,
  getUserFarms, getUserFarmsSuccess, getUserFarmsFail,
  getAnimalConditions, getAnimalConditionsSuccess, getAnimalConditionsFail,
  getAnimalTypes, getAnimalTypesSuccess, getAnimalTypesFail,
  getCattleBreeds, getCattleBreedsSuccess, getCattleBreedsFail,
  getHornStatus, getHornStatusSuccess, getHornStatusFail,
  getGoatBreeds, getGoatBreedsSuccess, getGoatBreedsFail,
  getSheepBreeds, getSheepBreedsSuccess, getSheepBreedsFail,
} = dynamicListSlice.actions

export default dynamicListSlice.reducer